<div [formGroup]="form">
  <div class="form-check" *ngFor="let opt of field.options">
    <input class="form-check-input" type="radio" [value]="opt.key" [name]="opt.name">
    <label class="form-check-label">
      {{opt.label}}
    </label>
  </div>
</div> 
